import { publicRequest } from "../../requestMeth";

export class ConsultantRequestError extends Error {
  constructor(kind, status) {
    super("Consultant request failed");
    this.name = "ConsultantRequestError";
    this.kind = kind;
    this.status = status;
  }
}

const errorKindForStatus = (status) => {
  if (status === 409) return "state_invalid";
  if (status === 401) return "session_expired";
  if (status === 403) return "context_forbidden";
  if (status === 504) return "timeout";
  if (status === 503) return "unavailable";
  if (status === 400) return "invalid_request";
  return "unexpected";
};

const cleanSuggestedActions = (actions) => (Array.isArray(actions) ? actions : [])
  .filter((action) => typeof action === "string" && action.trim())
  .slice(0, 10);

const cleanReportCharts = (charts) => (Array.isArray(charts) ? charts : [])
  .filter((chart) => chart && typeof chart === "object" && !Array.isArray(chart))
  .slice(0, 6);

export const sendConsultantMessage = async ({ token, payload }) => {
  try {
    const response = await publicRequest.post("/ai/consultant/chat", payload, {
      headers: { token: `Bearer ${token}` },
    });
    const data = response?.data;
    const answer = typeof data?.message === "string"
      ? data.message
      : (typeof data?.result === "string" ? data.result : null);
    if (
      !answer ||
      typeof data?.conversationId !== "string" ||
      typeof data?.conversationStateToken !== "string" ||
      !data?.conversationState ||
      typeof data.conversationState !== "object" ||
      Array.isArray(data.conversationState)
    ) {
      throw new ConsultantRequestError("unexpected", 502);
    }

    return {
      answer,
      conversationId: data.conversationId,
      conversationState: data.conversationState,
      conversationStateToken: data.conversationStateToken,
      clarificationRequired: Boolean(data.metadata?.clarificationRequired),
      clarificationQuestion: typeof data.metadata?.clarificationQuestion === "string"
        ? data.metadata.clarificationQuestion
        : null,
      suggestedActions: cleanSuggestedActions(data.metadata?.suggestedActions),
      reportCharts: cleanReportCharts(data.metadata?.reportCharts),
    };
  } catch (error) {
    if (error instanceof ConsultantRequestError) throw error;
    const status = Number(error?.response?.status) || 0;
    throw new ConsultantRequestError(errorKindForStatus(status), status);
  }
};
